import { Component } from 'react';
import { Link, Router } from '../configs/routes';
import { trackAction } from '../utils/trackActions';
import cx from 'classnames';
import { CDN_CLRSAVE_URL } from '../constants';

import styles from '../styles/header.scss';
import Button from '../components/ui/button';

interface State {
  openHamburgerMenu: boolean;
}

interface Props {
  isUserLoggedIn: boolean;
  alreadyInvested: boolean;
}

class MobileHeader extends Component<Props, State> {
  public state: State = {
    openHamburgerMenu: false,
  };

  private hamburgerMenuHandler() {
    const { openHamburgerMenu } = this.state;
    this.setState({ openHamburgerMenu: !openHamburgerMenu });
    document.body.style.overflow = openHamburgerMenu ? 'hidden' : 'auto';
  }

  private goToDashboardHandler() {
    trackAction('go-to-dashboard-click-mobile', 'index-mobile-go-to-dashboard');
    Router.pushRoute('/save/dashboard/portfolio');
  }

  private loginHandler() {
    trackAction('login-click-mobile', 'index-mobile-login');
    Router.pushRoute('/save/login');
  }

  private logoutHandler() {
    trackAction('logout-click-mobile', 'index-mobile-logout');
    window.location.href = '/save/logout';
  }

  private renderLogo = () => {
    const { openHamburgerMenu } = this.state;
    const { isUserLoggedIn } = this.props;
    return (
      <header className={cx('flex', styles['mobile-header-container'])}>
        <div className={cx('flex-1-0-0', 'mt10', 'ml15')}>
          <Link href={{ pathname: '/save' }}>
            <a id="header-logo" className={styles['cs-navbar--link']}>
              <img
                src={`${CDN_CLRSAVE_URL}/clearsave/images/clear_invest_logo.png`}
                alt="ClearTax"
                title="Home: ClearTax"
                height="18"
              />
            </a>
          </Link>
        </div>
        <div>
          <button
            onClick={() => {
              this.hamburgerMenuHandler();
            }}
            className={cx(
              styles['hamburger-menu-mobile'],
              { [styles['close']]: !openHamburgerMenu },
              { [styles['open']]: openHamburgerMenu },
              'mr10'
            )}
          />
        </div>
        <div
          className={cx(styles['hamburger-menu-items'], {
            [styles['open']]: openHamburgerMenu,
            ['hide']: !openHamburgerMenu,
          })}
        >
          <div className={cx(styles['hamburger-menu-container'], 'text--xmd')}>
            {isUserLoggedIn ? (
              <div
                className={cx('mb20')}
                onClick={() => {
                  this.goToDashboardHandler();
                }}
              >
                Go to Dashboard
              </div>
            ) : null}
          </div>
          {isUserLoggedIn ? (
            <div className={cx(styles['hamburger-btn-container'])}>
              <Button
                label="LOGOUT"
                disabled={false}
                className={cx(
                  'full-width',
                  'btn-blue-solid',
                  'bold',
                  'text--normal',
                  'letter-spacing-standard',
                  'mt10'
                )}
                loadingLabel="Loading..."
                onClick={() => {
                  this.logoutHandler();
                }}
              />
            </div>
          ) : (
            <div className={cx(styles['hamburger-btn-container'])}>
              <Button
                label="LOGIN/ SIGNUP"
                disabled={false}
                className={cx(
                  'full-width',
                  'btn-blue-solid',
                  'bold',
                  'text--normal',
                  'letter-spacing-standard',
                  'mt10'
                )}
                loadingLabel="Loading..."
                onClick={() => {
                  this.loginHandler();
                }}
              />
            </div>
          )}
        </div>
      </header>
    );
  };

  public render() {
    return <div>{this.renderLogo()}</div>;
  }
}

export default MobileHeader;



// WEBPACK FOOTER //
// ./components/MobileHeader.tsx